// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientBlock_root__1a1PA","header":"PatientBlock_header__17tf9","label":"PatientBlock_label__2HWQd","option":"PatientBlock_option__3slif"};